module.exports = __webpack_public_path__ + "static/media/shotglass.de7c4767.png";